import request from '../../shared/request'

export function deleteAllSelectedValues(formData) {
  return request('v1/services/destroy', {
    method: 'POST',
    body: JSON.stringify(formData),
  })
}
